import { Component, EventEmitter, Input, Output } from 'ng-metadata/core';
import './duplicate-docs.scss';

/**
 * @ngdoc directive
 * @name mwContentDocumentDuplicateDocs
 * @module mw.components.contentDocuments
 * @description
 * `mw-content-document-duplicate-docs` is a container for display duplicates
 * @usage
 * <hljs hljs-language="html">
 *  <mw-content-document-duplicate-docs> <some-new-component></some-new-component> </mw-content-document-duplicate-docs>
 * </hljs>
 */
@Component({
    selector: 'mw-content-document-duplicate-docs',
    template: `
        <div class="mw-content-document-duplicate-docs">
            <ng-transclude></ng-transclude>
        </div>
    `,
    legacy: {
        transclude: true
    }
})
export class DuplicateDocsComponent {}



// WEBPACK FOOTER //
// ./src/lib/components/content-documents/media-document/duplicate-docs/duplicate-docs.component.ts